import React, { useEffect } from 'react'
import { useStyles } from './FlyoutStorefrontMetrics.styles'
import { FlyoutStorefrontFilters } from './FlyoutStorefrontFilters/FlyoutStorefrontFilters'
import { useDispatch, useSelector } from '../../store'
import { MetricsData } from '../../modules/storefrontMetrics/reducer'
import { getStorefrontMetricsData } from '../../modules/storefrontMetrics/action'
import { Grid } from '@mui/material'
import { faGlobe } from '@fortawesome/pro-regular-svg-icons'
import { FlyOutStorefrontMetricsWrapper } from './FlyOutStorefrontMetricsWrapper/FlyOutStorefrontMetricsWrapper'
import { TrafficSources } from './TrafficSources/TrafficSources'
import { FlyOutImpressions } from './FlyOutImpressions/FlyOutImpressions'
import { TableAndConversionFunnel } from './TableAndConversionFunnel/TableAndConversionFunnel'
import { GraphAndMap } from './GraphAndMap/GraphAndMap'
import { LoadingLogo } from '@labrav/react-components'
import { LoadingTypes, isLoading as Loading } from '@labrav/common'
export const FlyoutStorefrontMetrics: React.FC = () => {
  const { classes } = useStyles()
  const dispatch = useDispatch()
  const metricsData = useSelector<MetricsData>(
    state => state.storefrontMetricsData
  )
  const isLoading = useSelector<boolean>(state =>
    Loading(state.loading)(LoadingTypes.METRICS_LOADING)
  )
  useEffect(() => {
    dispatch(getStorefrontMetricsData())
  }, [])
  if (isLoading) {
    return <LoadingLogo />
  }
  return (
    <div>
      <div className={classes.container}>
        <FlyoutStorefrontFilters />
        <FlyOutImpressions />
        <GraphAndMap />
        <TableAndConversionFunnel metricsData={metricsData} />
      </div>
      <Grid container className={classes.content} width={'100%'} spacing={4}>
        <Grid
          className={classes.container}
          size={{
            xs: 12,
            sm: 12,
            md: 12,
            lg: 6,
          }}
        >
          <FlyOutStorefrontMetricsWrapper
            children={<TrafficSources />}
            heading="Traffic sources"
            icon={faGlobe}
            infoTooltip={'Traffic sources'}
          />
        </Grid>
      </Grid>
    </div>
  )
}
